<template>
    <div class="tpl-page-container" style="padding: 0">
        <MainView></MainView>
    </div>
</template>

<script type="text/javascript">
    import MainView from '@/apps/plan/mobile_page/mobile_notes_view.vue'
    export default {
        name: "mynotes",
        components: {
            MainView,
        },
    }
</script>

<style type="text/css">
</style>